import { defineComponent, onMounted, onUnmounted } from 'vue';
import ErrorModal from '@/presentation/components/error-modal/error-modal.vue';
import AppCode from '@/presentation/app.code';

export default defineComponent({
	components: {
		ErrorModal
	},
	setup: () => {
		const code = new AppCode();

		onMounted(code.mounted.bind(code));
		onUnmounted(code.unmounted.bind(code));

		return {
			CurrentComponent: code.CurrentComponent,
			isErrorActive: code.isErrorActive
		};
	}
});
